import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import ButtonExternalLink from './UI/ButtonExternalLink';
import PhonePicture from './Pictures/PhonePicture';
import StatBox from './StatBox';
import Paragraph from './UI/Paragraph';
import Title from './UI/Title';
import data from '../assets/data/StatBox.json';
import LanguageContext from '../Context/Language';
import { renderStrong } from '../services/renderValues';

/**
 * ## Display the summary of my skills
 * Shows a short summary of my skills and some big numbers
 * like years of experience, etc.
 */
function Summary() {
  const statBoxes = data;
  const { language } = useContext(LanguageContext);
  const CVLink: string = language === 'fr-FR'
    ? '/gautier-labarre.pdf'
    : '/gautier-labarre-english.pdf';

  return (
    <>
      <div className="col-12 col-lg-5 col-xl-6">
        <div className="row">
          <Title level={2} custom css="text-uppercase mb-0 ft-wt-600 col-12">
            <FormattedMessage id="about.in-summary" />
          </Title>

          <PhonePicture />
          <article className="col-12">
            <Paragraph
              justify
              translationId="about.in-summary-p1"
              translationValues={{
                strong: renderStrong,
              }}
            />
            <Paragraph justify translationId="about.in-summary-p2" />
            <Paragraph justify translationId="about.in-summary-p3" />
          </article>

          <div className="col-12 text-center mt-3">
            <ButtonExternalLink
              link={CVLink}
              icon="btnDownload"
              id="downloadButton"
              download
            >
              <FormattedMessage id="about.download-resume" />
            </ButtonExternalLink>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-7 col-xl-6 mt-5 mt-lg-1">
        <div className="row">
          {statBoxes.map((stat) => (
            <div className="col-6" key={stat.text}>
              <StatBox title={stat.title}>{stat.text}</StatBox>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Summary;
